<template>
  <HScaffold title="返水" :hideNav="hideNav">
    <div style="display:flex;flex-direction: row;padding:5px;">
      <div style="display: flex;flex-direction: column;width:100px;margin-right: 3px;">
        <div @click="changeSwiperPage(index)" v-for="(item, index) in leftIconInfo" :key="index" :style="{
          backgroundColor:activeSwiperIndex === index?hcf.getMainColor()+'cc':hcf.getMainColor()+'1a',
        }" class="eachLeftDiv">
          <img :src="item['icon']" :style="['height:15px',activeSwiperIndex === index || HNewGameUIConfig.newGameUIType !== 0?'filter: brightness(0) invert(1);':'']" alt="">
          <div :style="hcf.getTextStyle({
            color:activeSwiperIndex === index?'white':'main',addSize:-2,marginLeft:2,
        })">{{item["title"]}}</div>
        </div>
      </div>
      <HSwiperLR ref="swiperLrRef" :height="rightHeight" :data="[1,2,3]" :onSwipeChange="onSwipeChange">
        <template #default="{ items, pageIndex }">
          <XimaFanshui v-if="pageIndex === 0"/>
          <FanshuiHistory :tag="tag" v-if="pageIndex === 1"/>
          <XimaHistory v-if="pageIndex === 2"/>
        </template>
      </HSwiperLR>
    </div>
    <HDatePicker v-if="!tag" onlyShowPopup="true"/>
  </HScaffold>

</template>


<script setup>
  import HScaffold from "@/components/utils/HScaffold.vue";
  import icon_left_fs from "@/assets/icons/discount/xm_left_fs.png";
  import icon_left_xmfs from "@/assets/icons/discount/xm_left_xmfs.png";
  import icon_left_xmjl from "@/assets/icons/discount/xm_left_xmjl.png";
  import {hcf} from "@/components/utils/HComFunctions.js";
  import XimaFanshui from "@/components/pages/Discount/XimaFanshui.vue";
  import FanshuiHistory from "@/components/pages/Discount/FanshuiHistory.vue";
  import XimaHistory from "@/components/pages/Discount/XimaHistory.vue";
  import HDatePicker from "@/components/utils/HDatePicker.vue";
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";

  defineProps(["hideNav","tag"]);

  const rightHeight = ref(window.innerHeight - 64);
  const activeSwiperIndex = ref(0);
  const swiperLrRef = ref();
  const leftIconInfo = ref([
    {
      title:"洗码返水",
      icon:icon_left_xmfs,
    },
    {
      title:"返水历史",
      icon:icon_left_fs,
    },
    {
      title:"洗码历史",
      icon:icon_left_xmjl,
    },
  ]);
  function changeSwiperPage(index){
    swiperLrRef.value.changeSwiperPage(index);
  }
  function onSwipeChange(index) {
    activeSwiperIndex.value = index;
  }

</script>


<style scoped>
  .eachLeftDiv{
    display: flex;flex-direction: row;align-items: center;border-radius: 6px;
    padding:10px 0;justify-content: center;margin-bottom: 12px;margin-right: 3px;
  }
</style>
